// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> amc-preferred-theme-preferred -> highlands-at-red-hawk
// Generated: 2026-10-08T20:11:36.784Z
// Counts: 1 design, 65 content, 37 slot group, 6 collection binding, 7 section, 1 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Availability and Pricing</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore <span data-type=\"field-token\" data-field=\"property_address_city\"></span> step by step.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-loader.javascript_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_apartmentsync_javascript_id"
  },
  "apply-now-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to make <span data-type=\"field-token\" data-field=\"property_name\"></span> your new home? Start your application online to take the next step toward finding an apartment that fits your needs. Complete the application below to get started.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.site_hash": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "the",
    "generatedValue": null,
    "mappedField": "custom_audioeye_site_hash"
  },
  "feeguide.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Fee Guide</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.label": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments</p>",
    "generatedValue": null,
    "mappedField": "property_bedrooms_range"
  },
  "floorplanslist.starting_at": {
    "overrideType": "VALUE",
    "customValue": "<p>Starting at $1,499</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Property Photos</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/lincoln-place-apartments-in-unit-laundry-loveland-co::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Experience the convenience of having in-unit laundry at Lincoln Place Apartments. Our Loveland, CO community offers modern living with top-notch amenities.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:hyperlocal::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with In-Unit Laundry in Loveland, CO</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicycontent.body": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1><p>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.</p><h2><strong>Information We Collect</strong></h2><p>We collect information from visitors on our Web site through online requests including:</p><ul><li><p>Contact Requests</p></li><li><p>Schedule a Tour Requests</p></li></ul><p>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.</p><h2>How the Information is Used</h2><p>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. In addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.</p><h2><strong>Sharing of Personal Information</strong></h2><p>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.</p><h2><strong>Security</strong></h2><p>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.</p><h2><strong>Cookies</strong></h2><p>From time to time, we may send a \"cookie\" to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer's hard drive. A cookie can't read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.</p><h2><strong>Links to Outside Sites</strong></h2><p>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.</p><h2><strong>Removal from Our Mailing List</strong></h2><p>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.</p><h2><strong>Contacting Us</strong></h2><p>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At <span data-type=\"field-token\" data-field=\"property_name\"></span> in vibrant <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span>, our residents celebrate the sense of community and comfort we offer. Dive into our reviews and see what else our satisfied tenants have to say about life at <span data-type=\"field-token\" data-field=\"property_name\"></span>!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "<p><span data-type=\"field-token\" data-field=\"property_company_name\"></span> logo</p>"
      }
    }
  },
  "header.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "<p><span data-type=\"field-token\" data-field=\"property_name\"></span> logo, <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>"
      }
    }
  },
  "petpolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166803/01a0f8c9-221f-7498-be1f-ab85f7304521.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Two adorable dogs relaxing on pillows on a cozy leather sofa indoors."
      }
    }
  },
  "accessibilityhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-44fa-703e-ab18-0c25cee416c8.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Leasing office entrance with mailboxes and reserved parking signs."
      }
    }
  },
  "amenitieshero.bg_image": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "applynowhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166794/019f805e-8a99-75e9-9d30-bbdbfca8fe3e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of apartment buildings with balconies and mountain backdrop."
      }
    }
  },
  "contacthero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-44fa-703e-ab18-0c25cee416c8.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Leasing office entrance with mailboxes and reserved parking signs."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-6e85-745f-9d56-60c048878435.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances and granite countertops"
      }
    }
  },
  "ctasection.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019fa565-a569-73f9-b5c2-16c0e9102bcb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Friends toasting with wine glasses during a dinner party."
      }
    }
  },
  "floorplanshero.bg_image": {
    "sourceIndex": 9,
    "fieldOverrides": null
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805e-b2e0-75e8-98c4-e9b2b849e952.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of apartment buildings at dusk with dramatic sunset sky."
      }
    }
  },
  "interactivemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805e-8a9d-71ff-ad8c-a48015aaa8c4.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a multifamily property with surrounding homes and a hilly landscape."
      }
    }
  },
  "neighborhoodcallout.image_1": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "neighborhoodcallout.image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019fa563-66e8-720b-8def-4e8b6171ee3d.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Golfer practicing putting on a golf course green with multiple golf balls lined up."
      }
    }
  },
  "neighborhoodcallout.image_3": {
    "sourceIndex": 33,
    "fieldOverrides": null
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805e-a7d6-7408-a339-0334239c9b12.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Apartment complex with garages and a mountain in the background."
      }
    }
  },
  "privacypolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805e-c21a-750c-88d1-14a4fc06b8fa.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of apartment buildings with balconies and lush green landscaping."
      }
    }
  },
  "propertyoverview.lifestyle_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166794/019fa565-a569-73f9-b5c2-16c0e9102bcb.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Friends toasting with wine glasses during a dinner party."
      }
    }
  },
  "propertyoverview.lifestyle_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166794/019fa565-a64b-73fb-8d27-5af7652dd8f3.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Three women enjoying a candlelit dinner with wine and food."
      }
    }
  },
  "propertyoverview.slide_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805e-c29f-747d-8acd-af61afbcf03a.webp"
      }
    }
  },
  "propertyoverview.slide_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805e-b2e0-75e8-98c4-e9b2b849e952.webp"
      }
    }
  },
  "propertyoverview.slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-9804-75fb-a674-ad42f7bad1b3.webp"
      }
    }
  },
  "propertyoverview.slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-7521-77c7-9c18-e408bbfe377a.webp"
      }
    }
  },
  "propertyoverview.slide_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805e-bef5-7409-a384-2270abd11e29.webp"
      }
    }
  },
  "propertyoverview.slide_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-4281-73aa-878d-ca13ccfd1b0c.webp"
      }
    }
  },
  "propertyoverview.slide_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805e-a7d6-7408-a339-0334239c9b12.webp"
      }
    }
  },
  "propertyoverview.slide_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-8aee-7517-b95d-f06eb7fdf9c8.webp"
      }
    }
  },
  "residentaccesshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-44fa-703e-ab18-0c25cee416c8.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Leasing office entrance with mailboxes and reserved parking signs."
      }
    }
  },
  "reviewshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166794/019fa565-a569-73f9-b5c2-16c0e9102bcb.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Friends toasting with wine glasses during a dinner party."
      }
    }
  },
  "scheduleatourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166794/019f805e-7b77-7266-8a47-3087c519102e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Apartment leasing office with building exteriors and mountain backdrop."
      }
    }
  },
  "sitemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805e-a7d6-7408-a339-0334239c9b12.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Apartment complex with garages and a mountain in the background."
      }
    }
  },
  "thankyouhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166794/019fa565-a569-73f9-b5c2-16c0e9102bcb.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Friends toasting with wine glasses during a dinner party."
      }
    }
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166794/019d02d0-52f8-7484-9f3a-90fdc32639ea.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room area with couch, coffee table, and TV."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": 10,
    "hiddenIds": null,
    "orderedIds": [
      "custom_5ad4b2e8-236c-4768-be2d-eb603ea523f2",
      "custom_60cb638c-dd81-4ef5-9109-fd25a5e82c69",
      "custom_090eaf92-c3fa-47ee-a53a-0b5f71df018a",
      "custom_0bae58fa-3a95-4182-8694-81ee357dba09",
      "custom_72acd6df-49c0-4f1b-8273-2c6ffe316896",
      "custom_5cd68923-239b-4c4d-b226-1c14d567d50c",
      "custom_5d87e27a-50ba-49d0-a56f-211450a99d17",
      "custom_f16d050f-8ac0-4426-b0a8-39992b478135",
      "custom_b026f11b-c920-4979-b461-f418c997694c",
      "custom_0c7b2fa6-107e-4630-a90d-4efaf361a8d3",
      "custom_1d6cd469-fe76-4858-9df1-3db574dddf7d",
      "custom_3364b999-7a94-4351-b7ab-cca4fd0b8fb9",
      "custom_a164c343-f010-413e-9297-5c80ab6fac4a",
      "custom_9e8cc2c9-2de1-4e70-b6b1-1d3bb0b7354f",
      "custom_afaa7935-9144-424d-b673-d5e6abec2ceb",
      "custom_143947b9-d892-4049-8b74-3ab9282a1ee2",
      "custom_13a412ea-3835-4770-9e89-e75d79f3e4bb",
      "custom_9fc4d69c-3808-4a29-9125-1d316196d5ca",
      "custom_93cfcdeb-4aab-4eee-8f99-0519593734ef",
      "custom_32b17d9b-feb6-406a-a4bd-8685338c2342",
      "custom_e7c72ec5-1a3e-4fde-853a-e97aadd131f7",
      "custom_9d6b1561-b4d0-46f9-928d-7a34674ba4c6",
      "custom_31802c92-a430-432f-9c64-b4ef74c35227",
      "custom_ee76161c-0be0-4581-86e4-c927da86f89b",
      "custom_a5968b40-0c5b-4663-9f1e-e761131eb0c5",
      "custom_d0bdaff4-a67e-48fa-810f-1771e1298a86",
      "custom_402f0f55-db9e-441e-b247-a154cfc5a29a",
      "custom_d089556e-15b5-40aa-924e-4c466f564198",
      "custom_828d748a-e40e-49c1-ac9b-34d24989e92d",
      "custom_bfc8072e-471b-4418-9980-b00e66fb0c9e",
      "custom_8e6da7c2-dc66-44fb-ae41-60f8ad69fdc0",
      "custom_45c306f2-4c11-4729-8979-f3bffcb0a72f",
      "custom_3da40094-1722-41f6-bd16-2748d634b229",
      "custom_4d8a044b-9954-4053-a870-1d5cd139be43",
      "custom_61c3ee9e-d8de-4fc1-a023-c19e9ff874d8",
      "custom_e453de83-9c32-45d3-83f4-9b51a9b0d3ee",
      "custom_aed97638-4ebb-4052-9ab5-8c3da677fe68",
      "custom_108d75cf-bfcc-4d5e-aba3-3ca76311bfd7",
      "custom_1f321fef-320f-48b8-b4f8-5ecb91e6bcab",
      "custom_b9970d2b-f46a-4f96-b031-a64c79ba3096",
      "custom_df9bba86-6c26-4a09-b8e7-a19b190042a3",
      "custom_fc9c4ebe-007c-4646-bcf5-03ef16816ded",
      "custom_76fab914-44f8-4297-812b-4a9d28c07abb",
      "custom_b83482d7-be16-4deb-904e-671316ff530d",
      "custom_4c7c3a49-99f6-4a75-b968-9208f3bf1acd",
      "custom_f74d464f-ced2-41cb-abc1-1f25b58b3372",
      "custom_54c3cc6b-0cfd-4f11-b96c-e30164bcccce",
      "custom_bf38c2cb-49be-4d65-80e7-5fc97a23e8af",
      "custom_313f8015-6e33-4957-a6ef-004721f9b77e"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.apartmentPhotos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_31802c92-a430-432f-9c64-b4ef74c35227",
      "custom_9fc4d69c-3808-4a29-9125-1d316196d5ca",
      "custom_1d6cd469-fe76-4858-9df1-3db574dddf7d",
      "custom_0bae58fa-3a95-4182-8694-81ee357dba09",
      "custom_9e8cc2c9-2de1-4e70-b6b1-1d3bb0b7354f",
      "custom_b83482d7-be16-4deb-904e-671316ff530d",
      "custom_61f58d1d-f5fe-4b22-8897-8613826ac1db",
      "custom_5ad4b2e8-236c-4768-be2d-eb603ea523f2",
      "custom_a164c343-f010-413e-9297-5c80ab6fac4a",
      "custom_835e549a-1ad8-4600-92f7-bd3ff5cf20c4",
      "custom_143947b9-d892-4049-8b74-3ab9282a1ee2",
      "custom_13a412ea-3835-4770-9e89-e75d79f3e4bb",
      "custom_1ff8ad0a-2b6f-4b35-bc00-2306f1302e73",
      "custom_7feb1554-9c6e-4fb8-bd1b-07dcece93117",
      "custom_93cfcdeb-4aab-4eee-8f99-0519593734ef",
      "custom_32b17d9b-feb6-406a-a4bd-8685338c2342",
      "custom_e7c72ec5-1a3e-4fde-853a-e97aadd131f7",
      "custom_9d6b1561-b4d0-46f9-928d-7a34674ba4c6",
      "custom_ee76161c-0be0-4581-86e4-c927da86f89b",
      "custom_828d748a-e40e-49c1-ac9b-34d24989e92d",
      "custom_bfc8072e-471b-4418-9980-b00e66fb0c9e",
      "custom_45c306f2-4c11-4729-8979-f3bffcb0a72f",
      "custom_3da40094-1722-41f6-bd16-2748d634b229",
      "custom_f16d050f-8ac0-4426-b0a8-39992b478135",
      "custom_4d8a044b-9954-4053-a870-1d5cd139be43",
      "custom_8bbcd2d4-c651-4041-bbb2-6a1b934e0e71",
      "custom_4c7c3a49-99f6-4a75-b968-9208f3bf1acd",
      "custom_54c3cc6b-0cfd-4f11-b96c-e30164bcccce",
      "custom_bf38c2cb-49be-4d65-80e7-5fc97a23e8af",
      "custom_4855a8af-75ec-4231-922b-e1af7897f9e0"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_3364b999-7a94-4351-b7ab-cca4fd0b8fb9",
      "custom_5cd68923-239b-4c4d-b226-1c14d567d50c",
      "custom_090eaf92-c3fa-47ee-a53a-0b5f71df018a",
      "custom_60cb638c-dd81-4ef5-9109-fd25a5e82c69",
      "custom_d089556e-15b5-40aa-924e-4c466f564198",
      "custom_e453de83-9c32-45d3-83f4-9b51a9b0d3ee",
      "custom_108d75cf-bfcc-4d5e-aba3-3ca76311bfd7",
      "custom_5a9c0a9c-1a1c-428c-8a9c-e289eb1eee70",
      "custom_aed97638-4ebb-4052-9ab5-8c3da677fe68",
      "custom_72acd6df-49c0-4f1b-8273-2c6ffe316896",
      "custom_616d42fd-4b31-4f88-a64e-89a608a42234",
      "custom_a5968b40-0c5b-4663-9f1e-e761131eb0c5",
      "custom_0c7b2fa6-107e-4630-a90d-4efaf361a8d3",
      "custom_5d87e27a-50ba-49d0-a56f-211450a99d17",
      "custom_b026f11b-c920-4979-b461-f418c997694c",
      "custom_d0bdaff4-a67e-48fa-810f-1771e1298a86",
      "custom_402f0f55-db9e-441e-b247-a154cfc5a29a",
      "custom_8e6da7c2-dc66-44fb-ae41-60f8ad69fdc0",
      "custom_61c3ee9e-d8de-4fc1-a023-c19e9ff874d8",
      "custom_1e7d39e3-d36b-40e8-883a-297b04d3579a",
      "custom_1f321fef-320f-48b8-b4f8-5ecb91e6bcab",
      "custom_b9970d2b-f46a-4f96-b031-a64c79ba3096",
      "custom_df9bba86-6c26-4a09-b8e7-a19b190042a3",
      "custom_fc9c4ebe-007c-4646-bcf5-03ef16816ded",
      "custom_afaa7935-9144-424d-b673-d5e6abec2ceb",
      "custom_a9f1deb0-8201-431f-ac16-ca941f2ac0cd",
      "custom_76fab914-44f8-4297-812b-4a9d28c07abb",
      "custom_08b480ea-0f72-41c4-8827-7e06ec297af1",
      "custom_e4ee2ef5-7d31-4ad9-9ffe-cf53190153a4",
      "custom_f74d464f-ced2-41cb-abc1-1f25b58b3372",
      "custom_2a5ee620-ebb6-4f69-8092-ab5823866c1e",
      "custom_313f8015-6e33-4957-a6ef-004721f9b77e",
      "custom_f6e89e0e-ddd8-4e75-aaae-3ee0af1822fb",
      "custom_605144f8-6831-41f2-ac3f-f2d3b3af4957",
      "custom_5b9fd2ba-7df3-4d5c-83df-b6276cf8b9e9",
      "custom_e88811a9-9088-48a9-af5c-9242c57de75e",
      "custom_39611682-a691-4781-829c-363a6fedeedc",
      "custom_e27a87da-b9b3-46df-8f6c-c37fd3275656"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "gallery.images": {
    "limit": null,
    "hiddenIds": [
      "custom_fc9c4ebe-007c-4646-bcf5-03ef16816ded",
      "custom_93cfcdeb-4aab-4eee-8f99-0519593734ef",
      "custom_f74d464f-ced2-41cb-abc1-1f25b58b3372",
      "custom_313f8015-6e33-4957-a6ef-004721f9b77e",
      "custom_54c3cc6b-0cfd-4f11-b96c-e30164bcccce",
      "custom_9fc4d69c-3808-4a29-9125-1d316196d5ca",
      "custom_5ad4b2e8-236c-4768-be2d-eb603ea523f2",
      "custom_9e8cc2c9-2de1-4e70-b6b1-1d3bb0b7354f",
      "custom_a164c343-f010-413e-9297-5c80ab6fac4a",
      "custom_0bae58fa-3a95-4182-8694-81ee357dba09",
      "custom_1d6cd469-fe76-4858-9df1-3db574dddf7d",
      "custom_df9bba86-6c26-4a09-b8e7-a19b190042a3",
      "custom_b9970d2b-f46a-4f96-b031-a64c79ba3096"
    ],
    "orderedIds": [
      "custom_3364b999-7a94-4351-b7ab-cca4fd0b8fb9",
      "custom_76fab914-44f8-4297-812b-4a9d28c07abb",
      "custom_b9970d2b-f46a-4f96-b031-a64c79ba3096",
      "custom_0c7b2fa6-107e-4630-a90d-4efaf361a8d3",
      "custom_1f321fef-320f-48b8-b4f8-5ecb91e6bcab",
      "custom_402f0f55-db9e-441e-b247-a154cfc5a29a",
      "custom_72acd6df-49c0-4f1b-8273-2c6ffe316896",
      "custom_61c3ee9e-d8de-4fc1-a023-c19e9ff874d8",
      "custom_a5968b40-0c5b-4663-9f1e-e761131eb0c5",
      "custom_8e6da7c2-dc66-44fb-ae41-60f8ad69fdc0",
      "custom_afaa7935-9144-424d-b673-d5e6abec2ceb",
      "custom_5cd68923-239b-4c4d-b226-1c14d567d50c",
      "custom_313f8015-6e33-4957-a6ef-004721f9b77e",
      "custom_fc9c4ebe-007c-4646-bcf5-03ef16816ded",
      "custom_d089556e-15b5-40aa-924e-4c466f564198",
      "custom_b026f11b-c920-4979-b461-f418c997694c",
      "custom_e453de83-9c32-45d3-83f4-9b51a9b0d3ee",
      "custom_60cb638c-dd81-4ef5-9109-fd25a5e82c69",
      "custom_5d87e27a-50ba-49d0-a56f-211450a99d17",
      "custom_108d75cf-bfcc-4d5e-aba3-3ca76311bfd7",
      "custom_aed97638-4ebb-4052-9ab5-8c3da677fe68",
      "custom_090eaf92-c3fa-47ee-a53a-0b5f71df018a",
      "custom_d0bdaff4-a67e-48fa-810f-1771e1298a86",
      "custom_df9bba86-6c26-4a09-b8e7-a19b190042a3",
      "custom_f74d464f-ced2-41cb-abc1-1f25b58b3372",
      "custom_a164c343-f010-413e-9297-5c80ab6fac4a",
      "custom_0bae58fa-3a95-4182-8694-81ee357dba09",
      "custom_93cfcdeb-4aab-4eee-8f99-0519593734ef",
      "custom_5ad4b2e8-236c-4768-be2d-eb603ea523f2",
      "custom_31802c92-a430-432f-9c64-b4ef74c35227",
      "custom_9fc4d69c-3808-4a29-9125-1d316196d5ca",
      "custom_13a412ea-3835-4770-9e89-e75d79f3e4bb",
      "custom_f16d050f-8ac0-4426-b0a8-39992b478135",
      "custom_e7c72ec5-1a3e-4fde-853a-e97aadd131f7",
      "custom_9d6b1561-b4d0-46f9-928d-7a34674ba4c6",
      "custom_32b17d9b-feb6-406a-a4bd-8685338c2342",
      "custom_1d6cd469-fe76-4858-9df1-3db574dddf7d",
      "custom_9e8cc2c9-2de1-4e70-b6b1-1d3bb0b7354f",
      "custom_143947b9-d892-4049-8b74-3ab9282a1ee2",
      "custom_45c306f2-4c11-4729-8979-f3bffcb0a72f",
      "custom_ee76161c-0be0-4581-86e4-c927da86f89b",
      "custom_3da40094-1722-41f6-bd16-2748d634b229",
      "custom_828d748a-e40e-49c1-ac9b-34d24989e92d",
      "custom_b83482d7-be16-4deb-904e-671316ff530d",
      "custom_54c3cc6b-0cfd-4f11-b96c-e30164bcccce",
      "custom_bfc8072e-471b-4418-9980-b00e66fb0c9e",
      "custom_4d8a044b-9954-4053-a870-1d5cd139be43",
      "custom_bf38c2cb-49be-4d65-80e7-5fc97a23e8af",
      "custom_4c7c3a49-99f6-4a75-b968-9208f3bf1acd"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "anyonehome-chatbot",
      "blockId": "anyonehome-chatbot",
      "position": 0
    },
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    }
  ],
  "interactive-map": [
    {
      "sectionId": "engrain-sitemap",
      "blockId": "engrain-sitemap",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  }
};
